"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCollectionUpdate = exports.useModifySharedCollection = exports.useWaitForCollectionValue = exports.useSingleCollectionValue = exports.useReadCollectionValue = exports.useSharedCollectionInitialization = exports.useSharedCollection = void 0;
const use_shared_value_1 = require("./use-shared-value");
const react_1 = require("react");
const shared_value_resolving_1 = require("./shared-value-resolving");
const context_1 = require("./context");
const use_singleton_initialization_1 = require("./use-singleton-initialization");
function useSharedCollection(key, keys) {
    if (keys === undefined) {
        return useAllSharedCollection(key);
    }
    else {
        return useFilteredSharedCollection(key, keys);
    }
}
exports.useSharedCollection = useSharedCollection;
function useFilteredSharedCollection(key, keys) {
    const context = (0, context_1.useSharedValueStoreContext)();
    const [values, setValues] = (0, react_1.useState)(() => context.get(key, keys));
    (0, shared_value_resolving_1.useCollectionValuesResolution)(key, keys, values);
    (0, use_shared_value_1.useLatestChanges)(() => context.changes(key, keys), () => {
        setValues(context.get(key, keys));
    });
    (0, react_1.useEffect)(() => setValues(context.get(key, keys)), [context, keys]);
    return values;
}
function useAllSharedCollection(key) {
    const context = (0, context_1.useSharedValueStoreContext)();
    const [values, setValues] = (0, react_1.useState)(() => context.getAll(key));
    (0, use_shared_value_1.useLatestChanges)(() => context.anyChanges(key), () => {
        setValues(context.getAll(key));
    }, [context]);
    (0, react_1.useEffect)(() => setValues(context.getAll(key)), [context]);
    return values;
}
/**
 * This hook defines an async initialization that will only be called once globally.
 * This allows a developer to define the init logic of a shared value inside it's hook
 * without initialization being triggered multiple times
 * @deprecated Use initializers instead
 * @param key The shared value key
 * @param init An async initialization function that returns the inital values of the collection
 */
const useSharedCollectionInitialization = (key, init) => {
    const context = (0, context_1.useSharedValueStoreContext)();
    const apply = (values) => {
        context.update(key, values);
    };
    return (0, use_singleton_initialization_1.useSingletonInitialization)(key, init, apply);
};
exports.useSharedCollectionInitialization = useSharedCollectionInitialization;
function useReadCollectionValue(key) {
    const context = (0, context_1.useSharedValueStoreContext)();
    return (0, react_1.useCallback)((valueKey) => context.get(key, valueKey), [context, key]);
}
exports.useReadCollectionValue = useReadCollectionValue;
function useSingleCollectionValue(key, valueKey) {
    const context = (0, context_1.useSharedValueStoreContext)();
    const [value, setValue] = (0, react_1.useState)(() => context.get(key, valueKey));
    (0, use_shared_value_1.useLatestChanges)(() => context.changes(key, valueKey), (newValue) => {
        setValue(newValue);
    }, [context, valueKey]);
    (0, react_1.useEffect)(() => setValue(context.get(key, valueKey)), [context, valueKey]);
    const updateValue = (newValue) => context.set(key, valueKey, newValue);
    return [value, updateValue];
}
exports.useSingleCollectionValue = useSingleCollectionValue;
function useWaitForCollectionValue(key, criteria) {
    const context = (0, context_1.useSharedValueStoreContext)();
    return function waitForValue(valueKey) {
        return context.waitFor(key, valueKey, criteria);
    };
}
exports.useWaitForCollectionValue = useWaitForCollectionValue;
/**
 * Allows the modification of a shared collection without triggering a render on components
 * that use this hook. If you need to get values out of a collection, use the useSharedCollection
 * hook.
 * @deprecated Use SharedValueEffects to do large scale modification of collections
 * @param key The key identifying the shared collection
 */
function useModifySharedCollection(key) {
    const context = (0, context_1.useSharedValueStoreContext)();
    return (0, react_1.useMemo)(() => ({
        setValue: (valueKey, value) => context.set(key, valueKey, value),
        update: update => context.update(key, update),
        delete: valueKeys => context.delete(key, valueKeys),
        clear: () => context.clear(key)
    }), [key, context]);
}
exports.useModifySharedCollection = useModifySharedCollection;
function toCollectionUpdate(objects, reduce) {
    return objects.reduce((update, obj) => {
        reduce(update, obj);
        return update;
    }, {});
}
exports.toCollectionUpdate = toCollectionUpdate;
//# sourceMappingURL=use-shared-collection.js.map